import {
  DONATION_DECISION,
  DONATION_DECISION_STEP,
  DONATION_DETAIL_ORIGIN,
  type DonationDecisionStep,
  type DonationDetailOrigin,
} from '../constants/marketPromotion.constants';
import type { MpApprovalRow } from '../types/marketPromotion.types';

export function getDonationDecisionStep(donation: MpApprovalRow): DonationDecisionStep | undefined {
  const hasRecommender = donation.recommendedBy !== null;
  if (donation.approveTypeNo === DONATION_DECISION.PENDING && !hasRecommender) {
    return DONATION_DECISION_STEP.recommend;
  }
  if (donation.approveTypeNo === DONATION_DECISION.RECOMMENDED) {
    return DONATION_DECISION_STEP.approve;
  }
  if (donation.approveTypeNo === DONATION_DECISION.REJECTED && hasRecommender) {
    return DONATION_DECISION_STEP.approve;
  }
  return undefined;
}

export const canDecideFrom = (from: DonationDetailOrigin): boolean =>
  from !== DONATION_DETAIL_ORIGIN.cashCollection;
